<template>
  <div class="application-thailand-pcd-picker">
    <el-select v-model="cityID" placeholder="城市" @change="changeCity()" class="pcd-picker">
      <el-option :label="v.name" :value="v.id" v-for="(v,k) in thailandRegion" :key="k"></el-option>
    </el-select>

    <el-select v-model="districtID" placeholder="地区" @change="changeDistrict()" class="pcd-picker">
      <el-option :label="v.name" :value="v.id" v-for="(v,k) in displayDistricts" :key="k"></el-option>
    </el-select>

    <el-select
      v-model="sub_districtID"
      placeholder="街道"
      @change="changeSubDistrict()"
      class="pcd-picker"
    >
      <el-option :label="v.name" :value="v.id" v-for="(v,k) in displaySubDistricts" :key="k"></el-option>
    </el-select>
  </div>
</template>

<script>
import _ from "lodash";
import applicationFormService from "../../../services/application-form-service";
import thailandRegion from "../../../datas/thailand-city.json";

export default {
  name: "application-thailand-pcd-picker",
  model: {
    prop: "value",
    event: "input",
  },
  props: {
    value: {
      type: Array,
      default: () => {
        [];
      },
    },
    field: {
      type: Object,
      required: true,
      default: () => ({}),
    },
    fieldIndex: {
      type: Number,
      required: true,
      default: 0,
    },
    fieldDisabled: {
      type: Boolean,
      required: true,
      default: false,
    },
    applicationData: {
      type: Object,
      required: true,
      default: () => ({}),
    },
  },
  data() {
    return {
      cityID: "",
      districtID: "",
      sub_districtID: "",
      thailandRegion,
      displayDistricts: [],
      displaySubDistricts: [],
    };
  },
  methods: {
    setDisplayDistricts() {
      setTimeout(() => {
        this.displayDistricts = this.cityID
          ? thailandRegion.find((cityInArr) => cityInArr.id === this.cityID)
              .district
          : [];
      }, 0);
    },

    setDisplaySubDistricts() {
      setTimeout(() => {
        if (this.cityID && this.districtID) {
          this.displaySubDistricts = this.displayDistricts.find(
            (districtInArr) => districtInArr.id === this.districtID
          ).sub_district;
        } else {
          this.displaySubDistricts = [];
        }
      }, 0);
    },

    // 切换城市
    changeCity() {
      const currentCityIndex = _.findIndex(
        thailandRegion,
        (cityInArr) => cityInArr.id === this.cityID
      );
      const currentCityDistricts =
        thailandRegion[currentCityIndex].district || [];
      const newDistrictID =
        _.findIndex(currentCityDistricts, (d) => d.id === this.districtID) > -1
          ? this.districtID
          : currentCityDistricts[0].id;

      const newDistrictIndex = _.findIndex(
        thailandRegion[currentCityIndex].district,
        (d) => d.id === newDistrictID
      );

      const currentCityDistictSubDistricts =
        thailandRegion[currentCityIndex].district[newDistrictIndex]
          .sub_district || [];
      const newSubDistrictID =
        _.findIndex(
          currentCityDistictSubDistricts,
          (sd) => sd.id === this.sub_districtID
        ) > -1
          ? this.sub_districtID
          : currentCityDistictSubDistricts[0].id;
      this.$emit("input", [this.cityID, newDistrictID, newSubDistrictID]);
      this.setDisplayDistricts();
      this.setDisplaySubDistricts();
    },

    // 切换地区
    changeDistrict() {
      const currentCityIndex = _.findIndex(
        thailandRegion,
        (cityInArr) => cityInArr.id === this.cityID
      );

      const currentDistrictIndex = _.findIndex(
        thailandRegion[currentCityIndex].district,
        (districtInArr) => districtInArr.id === this.districtID
      );

      const currentDistrictsSubDistricts =
        thailandRegion[currentCityIndex].district[currentDistrictIndex]
          .sub_district || [];
      const newSubDistrictID =
        _.findIndex(
          currentDistrictsSubDistricts,
          (sd) => sd.id === this.sub_districtID
        ) > -1
          ? this.sub_districtID
          : currentDistrictsSubDistricts[0].id;
      this.$emit("input", [this.cityID, this.districtID, newSubDistrictID]);
      this.setDisplaySubDistricts();
    },

    // 切换街道
    changeSubDistrict() {
      let result = [];

      if (this.cityID && this.districtID && this.sub_districtID) {
        this.$emit("input", [
          this.cityID,
          this.districtID,
          this.sub_districtID,
        ]);
      } else {
        this.$emit("input", []);
      }
    },

    // 没有默认值就加上默认值
    getDataCombineDefault(fieldData) {
      if (fieldData && fieldData.length > 0) return fieldData;
      const defaultCityID = thailandRegion[0].id;
      const defaultDistrictID = thailandRegion[0].district[0].id;
      const defaultSubDistrictID =
        thailandRegion[0].district[0].sub_district[0].id;
      return [defaultCityID, defaultDistrictID, defaultSubDistrictID];
    },

    // 响应外部设置数据
    setData(fieldData) {
      const [cityID, districtID, sub_districtID] = this.getDataCombineDefault(
        fieldData
      );
      console.log(cityID, districtID, sub_districtID);
      // if (cityID) {
      this.cityID = cityID;
      this.districtID = districtID;
      this.sub_districtID = sub_districtID;
      this.setDisplayDistricts();
      this.setDisplaySubDistricts();
      // }

      // if (districtID) {
      //   // 这里其实模拟的是用户下一次点击了
      //   this.$nextTick(() => {

      //     this.setDisplayDistricts();

      //     // 又模拟点了
      //     this.$nextTick(() => {
      //       if (sub_districtID) {
      //         this.sub_districtID = sub_districtID;
      //         this.setDisplaySubDistricts();
      //       }
      //     });
      //   });
      // }
    },
  },
  watch: {
    value(newValue) {
      if (newValue) {
        this.setData(newValue);
      }
    },
  },
  created() {
    if (this.value) {
      this.setData(this.value);
    }
  },
};
</script>

<style lang="less" scoped>
@import "../../../assets/less/variable";
div.application-thailand-pcd-picker {
  display: flex;
  .pcd-picker {
    margin-left: 10px;
    flex: 1;
    &:first-child {
      margin-left: 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/application/components/application-thailand-pcd-picker.vue